import apiClient  from './Client';

class FilesStorageService {
  async UploadCanvasImages(formData: FormData, IsGallary: boolean) {
    console.log(IsGallary);
    console.log(formData);
    try {
      const response = await apiClient.post(`/FilesStorage/upload-multiple-to-storage/${IsGallary}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response.data.filesUploadResponse);
      const filesUploadResponse = response.data.filesUploadResponse;
      return {
        totalFilesCount: filesUploadResponse.totalFilesCount,
        successCount: filesUploadResponse.successCount,
        errorCount: filesUploadResponse.errorCount,
        successFiles: filesUploadResponse.successFilesResponse,
        errorFiles: filesUploadResponse.errorFilesResponse,
      };
    } catch (error: any) {     
      throw error;
    }
  }
  
  
  async RetrievePhotos(productType: string, sortOrder: string, filter: string) { 
    try {
      const response = await apiClient.get(`/FilesStorage/retrieve-uploaded-photos/${productType}`, {
        params: {
          sortOrder,
          filter,
        },
      }); 
      console.log(response);
      return response.data;
    } catch (err: any) {
      if (err.response && err.response.status === 400) {
        console.log(err); 
        return "Failed to load images";
      }
    }
  }
  
    
    async DeleteImages(id: number){
      try {
        const response =  await apiClient.delete(`/FilesStorage/${id}`);
        return response.data;    
      } catch (error: any) {
        return error.response;
      }
    }
}
export default new FilesStorageService()